const UNIT_ALIASES: Record<string, string> = {
  g: 'g',
  ga: 'g',
  gauge: 'g',
  mm: 'mm',
  oz: 'oz',
  ml: 'ml',
  in: 'in',
  inch: 'in',
  k: 'k',
  kt: 'k',
};

const NUMBER = /^\d+(?:\.\d+)?(?:\/\d+)?$/;
const NUMBER_WITH_UNIT = /^(\d+(?:\.\d+)?(?:\/\d+)?)([a-z]+)$/;

function normalizeUnit(unit: string) {
  return UNIT_ALIASES[unit] ?? unit;
}

/** Fractions are inches by convention, so "3/8in" and "3/8" are one token. */
function withUnit(number: string, unit: string) {
  const normalized = normalizeUnit(unit);
  return number.includes('/') && normalized === 'in'
    ? number
    : `${number}${normalized}`;
}

/**
 * Lowercase word tokens with numbers and their units fused ("16 g", "16ga"
 * and "16g" all become "16g"); fractions such as 5/16 survive as one token.
 */
export function tokenize(text: string): string[] {
  const raw = text
    .toLowerCase()
    .split(/[^a-z0-9./]+/)
    .map(t => t.replace(/^[./]+|[./]+$/g, ''))
    .filter(Boolean);

  const tokens: string[] = [];
  for (let i = 0; i < raw.length; i += 1) {
    const token = raw[i];
    const next = raw[i + 1];
    const fused = token.match(NUMBER_WITH_UNIT);
    if (fused) {
      tokens.push(withUnit(fused[1], fused[2]));
    } else if (NUMBER.test(token) && next && UNIT_ALIASES[next]) {
      tokens.push(withUnit(token, next));
      i += 1;
    } else {
      tokens.push(token);
    }
  }
  return tokens;
}

/** Every query token must prefix-match some haystack token, in any order. */
export function matchesTokens(haystack: string[], query: string[]): boolean {
  return query.every(q => haystack.some(h => h.startsWith(q)));
}
